import { FC } from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { CheckCircle, WarningAmber } from "@mui/icons-material";
import { ResolvedCompetencyLink } from "../types";

type Props = {
  links: ResolvedCompetencyLink[];
  compact?: boolean;
};

export const CompetencyLinksList: FC<Props> = ({ links, compact = false }) => {
  if (links.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No competencies
      </Typography>
    );
  }

  if (compact) {
    return (
      <Stack direction="row" flexWrap="wrap" gap={0.5}>
        {links.map((link) => (
          <Chip
            key={link.csvName}
            size="small"
            icon={
              link.found ? (
                <CheckCircle fontSize="small" />
              ) : (
                <WarningAmber fontSize="small" />
              )
            }
            label={link.matchedName ?? link.csvName}
            color={link.found ? "success" : "warning"}
            variant="outlined"
          />
        ))}
      </Stack>
    );
  }

  return (
    <Stack spacing={1}>
      {links.map((link) => (
        <Box key={link.csvName} display="flex" alignItems="flex-start" gap={1}>
          {link.found ? (
            <CheckCircle color="success" fontSize="small" sx={{ mt: 0.25 }} />
          ) : (
            <WarningAmber color="warning" fontSize="small" sx={{ mt: 0.25 }} />
          )}
          <Box>
            <Typography variant="body2">
              {link.matchedName ?? link.csvName}
            </Typography>
            {!link.found && (
              <Typography variant="caption" color="warning.main">
                Not found in catalog
              </Typography>
            )}
            {link.found && link.matchedName !== link.csvName && (
              <Typography variant="caption" color="text.secondary">
                CSV: {link.csvName}
              </Typography>
            )}
          </Box>
        </Box>
      ))}
    </Stack>
  );
};
